import { ComponentProps } from 'react';

import { cn } from '@/app/shared/lib/cn';

export type ButtonVariant = 'primary' | 'secondary' | 'outline' | 'ghost';

export interface ButtonProps extends ComponentProps<'button'> {
  variant?: ButtonVariant;
}

export const Button = ({ className, variant = 'ghost', ...props }: ButtonProps) => {
  const variants = {
    primary: cn(
      'bg-brand-500 text-white',
      'enabled:hover:bg-brand-600',
      'enabled:active:bg-brand-700',
      'disabled:bg-brand-200 disabled:text-brand-100 disabled:cursor-not-allowed',
    ),
    secondary: cn(
      'bg-gray-800 text-white',
      'enabled:hover:bg-elevated-card-hover',
      'enabled:active:bg-gray-600',
      'disabled:bg-gray-900 disabled:text-gray-500 disabled:cursor-not-allowed',
    ),
    outline: cn(
      'bg-action-button text-white',
      'enabled:hover:bg-action-button-hover',
      'enabled:active:bg-action-button-active',
      'disabled:bg-action-button disabled:text-white disabled:opacity-30',
    ),
    ghost: cn(''),
  };

  return (
    <button
      className={cn(
        'flex items-center justify-center rounded-md px-4 py-2 font-medium transition-all duration-300 ease-in-out',
        'cursor-pointer disabled:cursor-not-allowed',
        variants[variant],
        className,
      )}
      {...props}
    />
  );
};
